import moment from 'moment';
import propTypes from 'prop-types';
import React from 'react';
import { SearchResults } from 'rp-bloodstock-search';

const DATE_FORMAT = 'YYYY-MM-DD';

export default function SalesResults({ data: { profile: { horseName } } }) {
    const from = moment().add(-1, 'years').format(DATE_FORMAT);
    const to = moment().format(DATE_FORMAT);
    return (
        <SearchResults
            sireName={horseName}
            from={from}
            to={to}
        />
    );
}

SalesResults.propTypes = {
    data: propTypes.shape({
        profile: propTypes.shape({
            horseName: propTypes.string.isRequired,
        }).isRequired,
    }).isRequired,
};



// WEBPACK FOOTER //
// ./src/js/horse/salesResults/SalesResults.jsx